'use client';

import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';

import { CustomProductsCarousel } from '@eliadmin/core/src/components/homepage/custom-products-carousel';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export function FirstStep({
  products,
  onProductSelect,
  selectedProductName,
  onNextStep,
}: {
  products: Product[];
  onProductSelect: (name: string) => void;
  selectedProductName: string;
  onNextStep: () => void;
}) {
  const { t } = useTranslations();

  return (
    <>
      <div className="flex w-full flex-col items-start justify-start gap-12">
        <div
          className={cn(
            'custom-container',
            'items-starts mx-auto mt-12 flex flex-col justify-start gap-12 md:mt-20',
          )}
        >
          <div className={cn('flex items-center justify-start gap-6 px-6 xl:px-0')}>
            <HtmlRendererRaw
              as="h2"
              className={cn(
                'max-w-[300px] text-3xl font-normal tracking-tighter sm:max-w-max sm:text-4xl lg:text-5xl xl:text-6xl',
              )}
              html={`<span class="text-primary font-light">01</span> ${t('text2021')}`}
            />
            <div className={cn('h-[2px] w-10 bg-black sm:w-12 md:w-16 lg:w-20')} />
          </div>
        </div>
        <CustomProductsCarousel
          products={products}
          inForm={true}
          onProductSelect={onProductSelect}
          selectedProductName={selectedProductName}
          onNextStep={onNextStep}
        />
      </div>
    </>
  );
}
